import SectionMessage from '@atlaskit/section-message/section-message';
import type { JSX } from 'react';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { useIntl } from 'react-intl';

import { registeredContent } from '../content';

export type TestMessageProps = {
	onDismiss: () => void;
};

export const TestMessage = ({ onDismiss }: TestMessageProps): JSX.Element => {
	const { formatMessage } = useIntl();
	const { onClosed } = usePostOfficeUserInteractions();
	const handleDismiss = () => {
		void onClosed({ interactionIdentifier: 'dismiss' });
		onDismiss();
	};

	return (
		<SectionMessage
			title={formatMessage(registeredContent.default.title)}
			appearance="information"
			isDismissible
			onDismiss={handleDismiss}
		>
			<p>{formatMessage(registeredContent.default.description)}</p>
		</SectionMessage>
	);
};
